import { IDIOMA_POR_OMISION } from '../idiomas';
import { es } from './es';
import { en } from './en';
import type { Mensajes } from './tipos';

export type { Mensajes };

/**
 * Diccionarios por código de idioma.
 *
 * `Record<string, Mensajes>` es lo que hace que un idioma incompleto **no
 * compile**: cualquier clave que le falte a un diccionario respecto del
 * español es un error de TypeScript aquí, no un texto en español apareciendo
 * en medio de la página inglesa en producción.
 */
export const DICCIONARIOS: Record<string, Mensajes> = { es, en };

/** Diccionario de un idioma, con el español como red por si el código no existe. */
export function mensajesDe(codigo: string): Mensajes {
  return DICCIONARIOS[codigo] ?? DICCIONARIOS[IDIOMA_POR_OMISION];
}
